"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerDetails = _interopRequireDefault(require("../styles/dealerDetails.css"));
var _cta = _interopRequireDefault(require("./cta"));
var _types = _interopRequireDefault(require("./types"));
var makeTestDriveURL = function makeTestDriveURL(baseURL, address, dealershipMarketId) {
  var checkBaseURL = baseURL.indexOf('<dealer_id>') !== -1 ? baseURL.replace('<dealer_id>', dealershipMarketId) : baseURL;
  return address ? encodeURI(checkBaseURL + "?dealerAddress=" + (address.addressLine1 || '') + " " + (address.addressLine2 || '') + " " + (address.addressLine3 || '')) : checkBaseURL;
};
var makeClickShopUrl = function makeClickShopUrl(baseURL, clickshopParamters, zipCode, dealershipMarketId, zipCodeDealer) {
  if (zipCodeDealer !== '') {
    return baseURL + "?zip-code=" + zipCodeDealer + "&" + clickshopParamters + "&dealership_oem_code=" + dealershipMarketId;
  }
  if (zipCode !== '') {
    zipCode = zipCode.replace(/[^0-9]/g, '');
    return baseURL + "?zip-code=" + zipCode + "&" + clickshopParamters + "&dealership_oem_code=" + dealershipMarketId;
  }
  return baseURL + "?" + clickshopParamters + "&dealership_oem_code=" + dealershipMarketId;
};
var departments = function departments(dealerDepartments) {
  return dealerDepartments.map(function (department) {
    return department.code && department.code;
  });
};
var SideBySideButtons = function SideBySideButtons(_ref) {
  var theme = _ref.theme,
    carServiceCTA = _ref.carServiceCTA,
    testDriveCTA = _ref.testDriveCTA,
    _ref$clickShopCTA = _ref.clickShopCTA,
    clickShopCTA = _ref$clickShopCTA === void 0 ? null : _ref$clickShopCTA,
    _ref$clickshopParamte = _ref.clickshopParamters,
    clickshopParamters = _ref$clickshopParamte === void 0 ? null : _ref$clickshopParamte,
    _ref$address = _ref.address,
    address = _ref$address === void 0 ? {} : _ref$address,
    _ref$zipCodeDealer = _ref.zipCodeDealer,
    zipCodeDealer = _ref$zipCodeDealer === void 0 ? '' : _ref$zipCodeDealer,
    _ref$dealerDepartment = _ref.dealerDepartments,
    dealerDepartments = _ref$dealerDepartment === void 0 ? [] : _ref$dealerDepartment,
    dealershipMarketId = _ref.dealershipMarketId,
    scheduleServiceLabel = _ref.scheduleServiceLabel,
    scheduleServiceUrl = _ref.scheduleServiceUrl,
    searchInventoryLabel = _ref.searchInventoryLabel,
    searchInventoryUrl = _ref.searchInventoryUrl,
    contactUsLabel = _ref.contactUsLabel,
    handleContactUsClick = _ref.handleContactUsClick,
    handleTestDriveClick = _ref.handleTestDriveClick,
    handleCarServiceClick = _ref.handleCarServiceClick,
    serviceWebsiteCTALabel = _ref.serviceWebsiteCTALabel,
    serviceWebsiteUrl = _ref.serviceWebsiteUrl,
    zipCode = _ref.zipCode;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _dealerDetails["default"].sideBySideButtons
  }, departments(dealerDepartments).indexOf('sales') > -1 && testDriveCTA.URL && /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    url: makeTestDriveURL(testDriveCTA.URL, address, dealershipMarketId),
    label: testDriveCTA.label ? testDriveCTA.label : '',
    ctaStyle: _dealerDetails["default"].detailsCta + " " + theme.critical + " first-cta",
    openNewTab: testDriveCTA.openNewTab,
    handleClick: handleTestDriveClick
  }), departments(dealerDepartments).indexOf('services') > -1 && carServiceCTA.URL && /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    url: makeTestDriveURL(carServiceCTA.URL, address, dealershipMarketId),
    label: carServiceCTA.label ? carServiceCTA.label : '',
    ctaStyle: _dealerDetails["default"].detailsCta + " " + theme.medium + " second-cta",
    openNewTab: carServiceCTA.openNewTab,
    handleClick: handleCarServiceClick
  }), searchInventoryLabel && searchInventoryUrl && /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    url: searchInventoryUrl,
    label: searchInventoryLabel,
    ctaStyle: _dealerDetails["default"].detailsCta + " " + theme.medium + " third-cta",
    openNewTab: carServiceCTA.openNewTab
  }), contactUsLabel && /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    label: contactUsLabel,
    ctaStyle: _dealerDetails["default"].detailsCta + " " + theme.medium + " forth-cta",
    handleClick: handleContactUsClick
  }), scheduleServiceLabel && scheduleServiceUrl && /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    url: scheduleServiceUrl,
    label: scheduleServiceLabel,
    ctaStyle: _dealerDetails["default"].detailsCta + " " + theme.medium + " fifth-cta",
    openNewTab: carServiceCTA.openNewTab
  }), serviceWebsiteCTALabel && serviceWebsiteUrl && /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    url: serviceWebsiteUrl,
    label: serviceWebsiteCTALabel,
    ctaStyle: _dealerDetails["default"].detailsCta + " " + theme.medium + " fifth-cta",
    openNewTab: true
  }), clickShopCTA.URL && clickshopParamters && /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    url: makeClickShopUrl(clickShopCTA.URL, clickshopParamters, zipCode, dealershipMarketId, zipCodeDealer),
    label: clickShopCTA.label,
    ctaStyle: _dealerDetails["default"].detailsCta + " " + theme.medium + " sixth-cta",
    openNewTab: clickShopCTA.openNewTab
  }));
};
var _default = SideBySideButtons;
exports["default"] = _default;